import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { RegistrationSearchParameters } from '@as-react/common-types';
import { getHomepageUrl } from '@as-react/common-utils';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Registration } from '../../components/account/registration/Registration';
import { DELAY } from '../../constants/GeneralConstants';
import { REGISTRATION_EMAIL } from '../../constants/StorageKeysConstants';
import { useOAuth } from '../../hooks/useOAuth';
import { authActions } from '../../redux/authentication/actions/AuthActions.creators';
import SessionStorageUtil from '../../util/SessionStorageUtil';
import { getQuerystringByName } from '../../util/URLParamUtil';
const AccountRegistrationContainer = props => {
    const dispatch = useDispatch();
    const { root } = useAemConfig();
    const { isLoggedIn } = useOAuth();
    const [defaultEmail, setDefaultEmail] = useState();
    const [shouldRender, setShouldRender] = useState(false);
    const getRedirectionLink = () => {
        const callbackUrl = getQuerystringByName(window.location.search, RegistrationSearchParameters.CALLBACK_URL);
        if (callbackUrl) {
            return decodeURIComponent(callbackUrl);
        }
        if (props.redirectUrl) {
            return props.redirectUrl;
        }
        return getHomepageUrl(root);
    };
    const getEmailFromStorage = () => {
        const registrationEmail = SessionStorageUtil.getJsonItem(REGISTRATION_EMAIL);
        SessionStorageUtil.removeItem(REGISTRATION_EMAIL);
        return registrationEmail;
    };
    useEffect(() => {
        if (shouldRender) {
            return;
        }
        setDefaultEmail(getQuerystringByName(window.location.search, RegistrationSearchParameters.EMAIL) ||
            getEmailFromStorage() ||
            undefined);
        setShouldRender(true);
    }, [shouldRender]);
    useEffect(() => {
        if (isLoggedIn) {
            setTimeout(() => {
                window.location.href = getRedirectionLink();
            }, DELAY.DELAY_500);
        }
    }, [isLoggedIn]);
    if (!shouldRender) {
        return null;
    }
    const handleRegistrationSuccess = (email, password) => {
        dispatch(authActions.login({
            username: email,
            password: password,
            keepSignedIn: false,
            reloadOnSuccess: false,
        }));
    };
    return _jsx(Registration, Object.assign({ onSuccess: handleRegistrationSuccess, defaultEmail: defaultEmail }, props));
};
export default AccountRegistrationContainer;
